(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-content"]) return;
  try {
    

  $('.CareersPage-jobHead').click(function(){
    let jobBtn = $(this).find('.CareersPage-jobBtn');

    if(jobBtn.hasClass('closed')){
      jobBtn.removeClass('closed').addClass('open');
      $(this).closest('.CareersPage-job').find('.CareersPage-jdWrap').slideDown();
       $(this).closest('.CareersPage-job').siblings('.CareersPage-job').find('.CareersPage-jdWrap').slideUp();
       $(this).closest('.CareersPage-job').siblings('.CareersPage-job').find('.CareersPage-jobBtn').removeClass('open').addClass('closed');
    }else{
      jobBtn.removeClass('open').addClass('closed');
      $(this).closest('.CareersPage-job').find('.CareersPage-jdWrap').slideUp();
      $(this).closest('.CareersPage-job').siblings('.CareersPage-job').find('.CareersPage-jdWrap').slideUp();
      $(this).closest('.CareersPage-job').siblings('.CareersPage-job').find('.CareersPage-jobBtn').removeClass('open').addClass('closed');
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["localization-dropdown"]) return;
  try {
    

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-waitlist"]) return;
  try {
    
 $('#PriceEqual-video').click(function(){
    $('#PriceEqual-video').pause();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["podcast-template"]) return;
  try {
    

    $('.Podcast-btn').click(function(){
      $(this).closest('.Podcast-epListItem').find('.Podcast-epDesc').slideToggle();
      $(this).toggleClass('hide');
      if ( $(this).hasClass('hide') ){
        $(this).text('+');
      }else{
        $(this).text('–');
      }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar-ca"]) return;
  try {
    
  $('.PromoBar2-btn').click(function(e){
    $('.PromoBar2-link.show').removeClass('show').addClass('hide').siblings('.PromoBar2-link').removeClass('hide').addClass('show');
  });
  if( $('.PromoBar2-link').length > 1 && $('.PromoBar').data('fading') === true ){
  (function myLoop(i) {
      setTimeout(function() {
         $('.PromoBar2-link.show').removeClass('show').addClass('hide').siblings('.PromoBar2-link').removeClass('hide').addClass('show');             
        if (--i) myLoop(i);   //  decrement i and call myLoop again if i > 0
      }, 6000)
    })(5);     

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"]) return;
  try {
    
  (function () {
    function initPromoBar(bar) {
      if (!bar || bar.dataset.promobarInit === 'true') return;
      bar.dataset.promobarInit = 'true';

      var slides = Array.prototype.slice.call(bar.querySelectorAll('.PromoBar-link'));
      if (slides.length < 2) return;

      var nextBtn = bar.querySelector('.PromoBar1-btn');
      var toggleBtn = bar.querySelector('[data-promobar-toggle]');
      var interval = parseInt(bar.dataset.promobarInterval, 10) || 6000;
      var rotationAllowed = bar.dataset.promobarRotate === 'true';
      var reduceMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var current = 0;
      var timer = null;
      var userPaused = reduceMotion; // sticky: controlled only by the Pause/Play button
      var pointerPaused = false;     // transient: hover
      var focusPaused = false;       // transient: keyboard focus inside the bar

      function setSlideState(slide, isActive) {
        if (isActive) {
          slide.classList.add('show');
          slide.classList.remove('hide');
          slide.hidden = false;
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
        } else {
          slide.classList.add('hide');
          slide.classList.remove('show');
          slide.hidden = true;
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
        }
      }

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) { setSlideState(slide, i === current); });
      }

      function advance() { show(current + 1); }

      function isPlaying() {
        return rotationAllowed && !userPaused && !pointerPaused && !focusPaused;
      }

      function updatePlayback() {
        if (isPlaying()) {
          if (!timer) timer = window.setInterval(advance, interval);
        } else if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function syncToggleButton() {
        if (!toggleBtn) return;
        toggleBtn.classList.toggle('is-paused', userPaused);
        toggleBtn.setAttribute('aria-label',
          userPaused ? 'Play promotional messages' : 'Pause promotional messages');
      }

      // Normalize initial state to the first slide
      show(0);

      // Manual advance (works whether playing or paused)
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          advance();
          if (isPlaying()) { // give the new message a full dwell
            window.clearInterval(timer);
            timer = null;
            updatePlayback();
          }
        });
      }

      // Sticky Pause / Play
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          userPaused = !userPaused;
          syncToggleButton();
          updatePlayback();
        });
      }

      // Transient pause on hover
      bar.addEventListener('mouseenter', function () { pointerPaused = true; updatePlayback(); });
      bar.addEventListener('mouseleave', function () { pointerPaused = false; updatePlayback(); });

      // Transient pause when keyboard focus is anywhere inside the bar
      bar.addEventListener('focusin', function () { focusPaused = true; updatePlayback(); });
      bar.addEventListener('focusout', function () {
        if (!bar.contains(document.activeElement)) { focusPaused = false; updatePlayback(); }
      });

      // Honor a live change in the reduced-motion preference
      if (window.matchMedia) {
        var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onMqChange = function (e) {
          if (e.matches) { userPaused = true; syncToggleButton(); updatePlayback(); }
        };
        if (mq.addEventListener) mq.addEventListener('change', onMqChange);
        else if (mq.addListener) mq.addListener(onMqChange);
      }

      syncToggleButton();
      updatePlayback();
    }

    function initAll() {
      var bars = document.querySelectorAll('.PromoBar');
      Array.prototype.forEach.call(bars, initPromoBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: re-init when the section is reloaded
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector ? e.target.querySelector('.PromoBar') : null;
      if (el) initPromoBar(el);
    });
  })();

  document.querySelectorAll('.js-promo-bar').forEach(function(bar){
    bar.addEventListener('touchstart', function(e){
      if(window.innerWidth > 768) return;
      e.preventDefault();
      e.stopPropagation();
      const trigger = bar.querySelector('.js-promo-modal-trigger');
      if(!trigger) return;
      const modal = document.getElementById('promoBarModal');
      modal.querySelector('.js-modal-title').innerHTML = trigger.dataset.title;

      modal.querySelector('.js-modal-content').innerHTML = trigger.dataset.content;
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';

    }, { passive:false });

  });

  document.addEventListener('click', function(e) {
    let trigger = e.target.closest('.js-promo-modal-trigger');
    if (!trigger && window.innerWidth <= 768) {
      trigger = e.target.closest('.js-promo-bar');
    }
    if (trigger) {
      if (trigger.classList.contains('js-promo-bar')) {
        trigger = trigger.querySelector('.js-promo-modal-trigger');
      }
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const modal = document.getElementById('promoBarModal');
      modal.querySelector('.js-modal-title').innerHTML = trigger.dataset.title;
      modal.querySelector('.js-modal-content').innerHTML = trigger.dataset.content;
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      return;
    }

    if ( e.target.closest('.custom-modal__close') || e.target.classList.contains('custom-modal__overlay')) {
      const modal = document.getElementById('promoBarModal');
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const modal = document.getElementById('promoBarModal');
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-template"]) return;
  try {
    

$('.CollectionTypesNav-link').click(function(e) {
  e.preventDefault();
  let the_link = $(this).attr('href');
  let the_offset = $(the_link).offset().top;
  //alert(the_offset);
  the_offset = the_offset - 90;
  $('html, body').animate({
    scrollTop: the_offset
  }, 500);
  $(this).closest('.CollectionTypesNav-item').addClass('is-active').siblings('li').removeClass('is-active');
});

$('.RewardsFaq-item').click(function(){
  $(this).find('p').slideToggle('fast');
  $(this).find('p').toggleClass('open');
  if( $(this).find('p').hasClass('open')  ){
    console.log('hidden');
      $(this).find('.RewardsFaq-btn').text('–');
  }else{
    console.log('not hidden');
    $(this).find('.RewardsFaq-btn').text('+');
    
  }
});
setTimeout(function(){ 
  $('.lion-tier-box--current').find('.lion-tier-box__position').show(); 
  //let the_status =  $('.lion-tier-box--current').find('.lion-tier-box__title').text();


}, 500);





  } catch(e) { console.error(e); }
})();
})();
